import constants from "@/constants.js";
import axios from "@/axios.js";
import { i18n } from "@/main.js";


export default {
  getFaculdades(lang){
    return axios.get(`/testemunhos/faculdades?idioma=${i18n.global.locale}`).
      then(data => {
        return data.data.sort((a,b) => a.ordem - b.ordem).
          map(el => {
            return {
              ...el,
              label: el.nome,
              value: el.id
            }
          });
      }).catch(error => {
        throw error; 
      });
  },
  getCursos(lang){
    return axios.get(`/testemunhos/cursos?idioma=${i18n.global.locale}`).
      then(data => {
        return data.data.map(el => {
          return {
            ...el,
            label: el.name,
            value: el.ID,
          }
        });
    }).catch(error => {
      throw error; 
    });
  },
  getTestemunhos(idcurso,idFaculdade,lang){

    const url = generateUrl(idcurso,idFaculdade,i18n.global.locale);
    return axios.get(url)
      .then(data => {
        return data.data.map(el => {
          return {
            id: el.ID,
            nome: el.Identificacao,
            depoimento: truncate(el.Depoimento,constants.maxChars," (...)"), 
            imagem: el.Imagem,
            curso: el.Curso.post_title,
            cursoid: el.Curso.ID,
            url: el.Url,
            faculdadename: el.Faculdade.name,
            name: el.Name,
          };
        });
      })
      .catch(error => {
        console.log(error);
        throw error; 
      })
  },
  getTestemunhosForCurso(cursoId){
    return axios
      .get(`/testemunhos?curso=${cursoId}&lang=${i18n.global.locale}`)
      .then(data => {
        return data.data.map(el => {
          return {
            ...el,
            Depoimento: truncate(el.Depoimento,constants.maxChars," (...)")
          }
        });
      })
      .catch((error) => {
        throw error;
      });
  },
  getTestemunhosByName(name){
    console.log("services > getTestemunhosByName");
    console.log("name: ",name);
    return axios
      .get(`/testemunhos/${name}`)
      .then(data => {
        console.log(data.data);
        return data.data;
      })
      .catch((error) => {
        throw error;
      });    
  }
}

const truncate = (str, max, suffix) => {
  return str.length < max ?
      str :
      `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`
}  

const generateUrl = (idCurso, idFaculdade,lang) => {
  let url = `${import.meta.env.VITE_APP_AXIOS}/testemunhos?idioma=${lang}`;
  if (idCurso != null) {
    url = url + "&curso=" + idCurso;
  }
  if (idFaculdade != null) {
    url = url + "&faculdade=" + idFaculdade;
  }
  return url;
}

